import styled from "styled-components";

export const GammaLoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;